// @ts-check
import { TypeTester } from "./TypeTester";

/**
 *
 * @param {TypeTester} typeTester
 */
export function buildFontScalerForTypeTester(typeTester) {
  // @ts-ignore
  const FontScaler = window.FontScaler;

  const fontScaler = new FontScaler(typeTester.renderedTextElement, {
    ...typeTester.props.options.fontScaler,
    ...typeTester.props.options,
    dimensionElement: typeTester.element,
    loggingId: typeTester.loggingId,
  });

  typeTester.renderedTextElement.addEventListener("change", (event) => {
    fontScaler.automaticColumnsEnabled =
      event.detail.format.automaticColumnsEnabled;
  });

  // Update values on change
  typeTester.addEventListener("change", (event) => {
    /** @type {import("./types").TypeTesterChangeEventDetail} */
    // @ts-ignore
    const detail = event.detail;

    let changed = false;
    const newLineHeight = detail.format.lineHeight
      ? parseFloat(detail.format.lineHeight) / 100
      : null;

    if (fontScaler.lineHeight != newLineHeight) {
      fontScaler.lineHeight = newLineHeight;
      // this.log("line height changed", fontScaler.lineHeight);
      changed = true;
    }

    const newFontSize = parseFloat(detail.format.fontSize);
    if (fontScaler.unscaledFontSize != newFontSize) {
      fontScaler.unscaledFontSize = newFontSize;
      // this.log("font size changed", fontScaler.unscaledFontSize);
      changed = true;
    }

    const newColumns = detail.format.columns;
    if (fontScaler.columns !== newColumns) {
      fontScaler.columns = newColumns;
      // this.log("columns changed", this.columns);
      changed = true;
    }

    if (fontScaler.fontSettings !== detail.format.fontSettings) {
      fontScaler.fontSettings = detail.format.fontSettings;
      // this.log("font settings changed", fontScaler.fontSettings);
      changed = true;
    }

    if (fontScaler.textLength !== detail.textLength) {
      fontScaler.textLength = detail.textLength;
      changed = true;
    }

    if (changed) {
      fontScaler.resizeIfActive();
    }
  });

  return fontScaler;
}
